import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { creatorListingsPath, serviceCreatorStagePath } from "@travily/routes";
import type ListingsCreatorTagline from "@travily/types/pages/ListingsCreatorTagline";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { ServiceTaglineStepView } from "./show.view";

type PageProps = ListingsCreatorTagline;

type FormData = {
  tagline: string;
};

const ServiceTaglineStep = ({ listing_id, stage_index, stage_order, tagline }: PageProps) => {
  const { bindField, currentStage, totalStages, onBack, onPrimary, onEnterSubmit, primaryPending } =
    useWizardForm<FormData>({
      routes: {
        stageUrl: (stage) => serviceCreatorStagePath(listing_id, stage),
        entryUrl: creatorListingsPath(),
      },
      stageName: "tagline",
      stageIndex: stage_index,
      stageOrder: stage_order,
      initialData: { tagline: tagline ?? "" },
    });
  const taglineField = bindField("tagline", { validateOn: "change" });

  const topBarActions = useCreatorTopBarActions({ saveHref: creatorListingsPath() });

  return (
    <>
      <Head title={t("web.services.creator.steps.tagline.show.meta_title")}>
        <meta name="description" content={t("web.services.creator.steps.tagline.show.meta_description")} />
      </Head>
      <ServiceTaglineStepView
        currentStage={currentStage}
        totalStages={totalStages}
        onBack={onBack}
        topBarActions={topBarActions}
        onPrimary={onPrimary}
        primaryPending={primaryPending}
        tagline={taglineField.value}
        error={taglineField.errorMessage}
        onTaglineChange={taglineField.onChange}
        onTaglineBlur={taglineField.onBlur}
        onEnterSubmit={onEnterSubmit}
      />
    </>
  );
};

export default ServiceTaglineStep;
